import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Category from './components/Category';

[...document.querySelectorAll('.learning-resource-category[data-id]')].forEach((element) => {
  const categoryId = element.dataset['id'];
  ReactDOM.render(<Category categoryId={categoryId}/>, element);
});
